import React from "react";
import IncompleteProfileStepsContext from "../Context/IncompleteProfileStepsContext";



class IncompleteProfileStepsContextProvider extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoad: false,
            isError: false,
            isProfileComplete: false,
            isEmailVerified: false,
            data: null
        };
    }

    componentDidUpdate(prevProps) {

        if (prevProps.isChange === undefined) {
            return;
        }

        const arr = Object.keys(prevProps.isChange);
        for (let i = 0; i < arr.length; i++) {
            if (prevProps.isChange[arr[i]] === this.props?.isChange[arr[i]]) {
                continue;
            }


            this.componentDidMount();
            return;
        }

        return;
    }


    componentDidMount = async () => {
        this.setState({ isLoad: true });
    }


    render = () => {
        if (this.state.isLoad === true) {
            return (
                <IncompleteProfileStepsContext.Provider value={{ value: this.state }}>
                    {this.props.children}
                </IncompleteProfileStepsContext.Provider>
            );
        }
    }

}

export default IncompleteProfileStepsContextProvider;